<template lang="pug">
  v-form(ref="form")
    v-row(no-gutters)
      v-col(:cols="blast.enabled ? 12 : 7")
        v-card.rounded-lg.content-box.pa-6(outlined)
          v-row
            v-col(:cols="blast.enabled ? 7 : 12")
              v-row(no-gutters align="center")
                v-col.grow
                  div.d-flex.align-center
                    .text-md.font-semibold Email delivery
                    y-chip.ml-2(v-if="blastData && blast.enabled && checkPaused(blastData)" label="Paused" color="red")
                v-col.shrink(v-if="blastData && blast.enabled && offer.status !== 'draft'")
                  y-button.mr-3(label="Deliverance details" outlined size="xxs" @click="showDeliveranceDetailsDialog = true")
                v-col.shrink
                  y-switch.mb-n3(v-model="blast.enabled")

              v-row.my-4(v-if="blast.enabled")
                v-divider.neutral300

              template(v-if="blast.enabled")
                //- Thank you email
                div.text-md.font-semibold.neutral700--text Thank you email
                div.text-sm.neutral700--text Configure your thank you email
                //- Email subject line
                div.text-md.font-semibold.neutral700--text.mt-5 Email subject line
                v-text-field.text-sm.mt-2.round-xl(v-model="blast.subject" placeholder="Enter email subject line here" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                div.text-xs.neutral500--text.ml-3.mt-2 The email subject line is only used when sending email
                //- Email preview text
                div.text-md.font-semibold.neutral700--text.mt-5 Email preview text
                v-text-field.text-sm.mt-2.round-xl(v-model="blast.preview_text" placeholder="Enter email notification preview line" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
                div.text-xs.neutral500--text.ml-3.mt-2 This text will appear in the inbox after the subject line

            v-divider.neutral300.my-n3(v-if="blast.enabled" vertical)
            //- Email preview
            v-col.py-0(v-if="blast.enabled" cols="5")
              email-preview(:subject-line="blast.subject" :notification-preview-line="blast.preview_text")

          template(v-if="blast.enabled")
            v-row.mt-6
              v-divider.neutral300
            //- Thank you email content
            div.text-md.font-semibold.neutral700--text.mt-6 Thank you email content
            page-editor.mt-3.mx-(v-if="showFroala" :parentForm.sync="blast.content")
            div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
            div.d-flex.align-center.mt-1
              v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('offer_name')")
                span.neutral700--text Offer details
              v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('recipient_name')")
                span.neutral700--text Customer name
              v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('company_name')")
                span.neutral700--text Clinic’s name
              v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('company_phone')")
                span.neutral700--text Phone number
              template(v-if="offer.redeem_method != 'show_message'")
                v-chip.mr-3(link small outlined color="neutral400" @click="insertValue('offer_code')")
                  span.neutral700--text Promo code
              v-chip.mr-3(v-if="offer.end_at" link small outlined color="neutral400" @click="insertValue('expiry_date')")
                span.neutral700--text Expiry date
            //- Blast settings
            div.text-sm.font-semibold.neutral700--text.mt-6 Blast settings
            v-card.round-xl.mt-2.pa-3(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
              v-radio-group.mt-0(v-model="blast.send_to" hide-details)
                v-radio(value="all" color="neutral700")
                  template(v-slot:label)
                    div.text-sm.font-medium.neutral700--text Send to everyone
                div.ml-8.mb-3(v-if="blast.send_to === 'all'")
                  v-radio-group.mt-0(v-model="sendCue" hide-details)
                    v-radio(value="scheduled" color="neutral700")
                      template(v-slot:label)
                        div.text-sm.font-medium.neutral700--text On specific date and time
                    template(v-if="sendCue === 'scheduled'")
                      v-row.mb-2.ml-6(dense)
                        v-col(cols="4")
                          date-picker-field(v-model="date" required :min="getTodayDate()")
                        v-col(cols="4")
                          v-text-field.text-sm.round-xl(v-model="time" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                    v-radio(value="offer_ended" color="neutral700")
                      template(v-slot:label)
                        div.text-sm.font-medium.neutral700--text Right after the campaign ended
                v-radio(value="redeemed_recipient" color="neutral700" style="align-items: unset;")
                  template(v-slot:label)
                    div.text-sm.font-medium.neutral700--text Send to customer that redeemed the offer
                div.ml-8(v-if="blast.send_to === 'redeemed_recipient'")
                  v-radio-group.mt-0(v-model="sendCue" hide-details)
                    v-radio(value="offer_redeemed" color="neutral700")
                      template(v-slot:label)
                        div.text-sm.font-medium.neutral700--text Send after specific minute after redemption
                    template(v-if="sendCue === 'offer_redeemed'")
                      v-row.mb-3(no-gutters)
                        v-col(cols="6")
                          v-text-field.text-sm.round-xl.pl-8(v-model="minutes" placeholder="0" outlined dense height="48" :rules="rules.has_quantity" suffix="minute" type="number" hide-details="auto")
                    v-radio(value="scheduled" color="neutral700")
                      template(v-slot:label)
                        div.text-sm.font-medium.neutral700--text On specific date and time
                    template(v-if="sendCue === 'scheduled'")
                      v-row.mb-3.ml-6(dense)
                        v-col(cols="4")
                          date-picker-field(v-model="date" required :min="getTodayDate()")
                        v-col(cols="4")
                          v-text-field.text-sm.round-xl(v-model="time" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                    v-radio(value="offer_ended" color="neutral700")
                      template(v-slot:label)
                        div.text-sm.font-medium.neutral700--text Right after the campaign ended

    .dialogs
      deliverance-details-dialog(v-if="showDeliveranceDetailsDialog" :open.sync="showDeliveranceDetailsDialog" :blast-data="blastData")

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {DateTime} from 'luxon'
import PageEditor from '@/components/clinic/PageEditor.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import EmailPreview from '@/components/clinic/marketing/EmailPreview.vue'
import DeliveranceDetailsDialog from '@/components/clinic/marketing/dialogs/DeliveranceDetailsDialog.vue'

export default {
  components: {
    PageEditor, DatePickerField, EmailPreview, DeliveranceDetailsDialog
  },
  props: {
    blastData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isFetching: false,
      showDeliveranceDetailsDialog: false,
      showFroala: false,
      minutes: 0,
      sendCue: 'offer_ended',
      time: '00:00',
      date: null,
      blast: {
        name: 'Thank you message',
        send_to: 'all',
        type: 'thank_you',
        method: 'email',
        enabled: false,
      },
      schedules: [{time: '00:00'}],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer'
    }),
  },
  mounted() {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData() {
      this.$nextTick(() => {
        this.showFroala = true
      })
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        if (blast.schedules.length) {
          this.date = DateTime.fromISO(blast.schedules[0].scheduled_for).toFormat('yyyy-MM-dd'),
              this.time = DateTime.fromISO(blast.schedules[0].scheduled_for).toFormat('HH:mm')
        }
        this.sendCue = blast.send_cue
        this.minutes = blast.auto_send_delay_time_value
        this.blast = blast
      }
    },
    insertValue(value) {
      let text = ''
      const code = `{{ ${value} }}`
      if (this.blast.content) {
        text = `${this.blast.content} ${code}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    deleteSchedule() {
      this.schedules.pop()
    },
    validateData () {
      return this.$refs.form.validate()
    },
    saveData () {
      if (!this.validateData()) {
        return
      }
      if (!this.blastData && !this.blast.enabled) {
        return
      }
      const payload = this.getPayload()
      if (this.blast.id) {
        return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
      }
      return this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
    },
    getTodayDate() {
      return DateTime.local().toFormat('yyyy-MM-dd')
    },
    getPayload () {
      if (!this.blast.enabled) {
        return {
          enabled: false
        }
      }
      let payload = {
        enabled: true,
        name: this.blast.name,
        method: this.blast.method,
        type: this.blast.type,
        preview_text: this.blast.preview_text,
        subject: this.blast.subject,
        content: this.blast.content,
        send_to: this.blast.send_to,
      }
      payload.send_cue = this.sendCue
      if (this.sendCue === 'scheduled') {
        payload.schedules = [`${this.date} ${this.time}`]
      }
      if (this.sendCue === 'offer_redeemed') {
        payload.auto_send_delay_time_value = this.minutes
        payload.auto_send_delay_time_unit = 'minutes'
      }
      return payload
    },
    checkPaused (data) {
      let paused = false
      if (data.schedules.find(f => f.status === 'paused')) {
        paused = true
      }
      return paused
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover {
    cursor: pointer;
    background: var(--v-neutral200) !important;
  }

  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }

  .error--text {
    color: var(--v-danger500) !important;

    fieldset {
      border-color: var(--v-danger500);
    }
  }

  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>